/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/fenced-imports */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Breadcrumb } from "@coveo/headless/commerce";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import translate from "@insite/client-framework/Translate";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Tag, { TagPresentationProps } from "@NA/MobiusOverrides/Tag";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import showMobileFilters from "@NA/Handlers/ADIShowMobileAttributeFilterHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import { withCoveoHooks, HasCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => ({
    attributeTypeFacets: [] as AttributeTypeFacetModel[],
    showMobileFiltersState: state.ADIGlobalData.ADIMobileFilterStore.showMobileFilters as any,
});

const mapDispatchToProps = {
    removeProductFilters,
    clearAllProductFilters,
    showMobileFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps & HasCoveoHooks;

export interface ProductListFilterListStyles {
    wrapper?: InjectableCss;
    skipFiltersButtonWrapper?: InjectableCss;
    skipFiltersButton?: SkipNavStyles;
    filterText?: TypographyPresentationProps;
    filterTag?: TagPresentationProps;
    clearAllLink?: LinkPresentationProps;
    appliedFiltersContainer?: InjectableCss;
    allTagsContainer?: InjectableCss;
    tagsContainer?: InjectableCss;
    mobileExpandContainer?: InjectableCss;
    mobileClearAll?: InjectableCss;
    mobileContainer?: InjectableCss;
    mobileFilters?: InjectableCss;
    toggleMsg?: TypographyProps;
    categoryHirerachy?: InjectableCss;
    title?: InjectableCss;
    appliedFiltersText?: InjectableCss;
}

export const filterListStyles: ProductListFilterListStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        `,
    },
    title: {
        css: css`
            font-size: 14px;
        `,
    },
    filterText: {
        variant: "h3",
        css: css`
            margin-bottom: 0;
            font-size: ${getProp("theme.typography.h6.size")};
            font-weight: 800;
        `,
    },
    skipFiltersButtonWrapper: {
        css: css`
            position: relative;
            top: -65px;
            width: 100%;
        `,
    },
    clearAllLink: {
        css: css`
            padding-bottom: 0px;
        `,
    },
    appliedFiltersContainer: {
        css: css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            border-top: 1px solid ${getColor("text.disabled")};
            padding: 10px 0;
        `,
    },
    appliedFiltersText: {
        css: css`
            font-weight: bold;
        `,
    },
    tagsContainer: {
        css: css`
            width: 100%;
            background-color: ${getColor("text.disabled")};
            padding: 0 10px;
            @media (max-width: 900px) {
                padding: 0;
                background: none;
            }
        `,
    },
    allTagsContainer: {
        css: css`
            width: 100%;
            background-color: ${getColor("text.disabled")};
            border-radius: 4px;
            display: flex;
            flex-wrap: wrap;
            @media (max-width: 900px) {
                align-items: baseline;
                background: none;
            }
        `,
    },
    filterTag: {
        css: css`
            background-color: transparent;
            flex-direction: row-reverse;
            padding: 0;
            margin: 0 10px 5px 0 !important;
            span {
                font-size: 12px !important;
                text-decoration: none;
                color: #000;
            }
            button {
                margin-left: 0;
                height: auto;
                flex-basis: auto;
                background: transparent;
                min-height: initial;
                font-size: 14px;

                :hover {
                    background-color: transparent;
                }
                span {
                    margin-left: 0;
                    width: auto;
                    height: auto;
                    svg {
                        width: 15px;
                        height: 15px;
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            flex-direction: row;
                            border-radius: 4px;
                            background-color: ${getColor("text.disabled")};
                            font-size: ${getProp("theme.typography.headerSecondary.size")};
                            font-weight: bold;
                            line-height: normal;
                            color: #666 !important;
                            padding: 5.5px 10px 3.5px;
                            margin: 0;
                            display: inline-flex;
                            align-items: center;
                            margin: 0 9px 0 0;
                            span {
                                text-decoration: none;
                            }
                            button {
                                span {
                                    top: 1px !important;
                                }
                            }
                        `,
                        css`
                            flex-direction: row;
                            border-radius: 4px;
                            background-color: ${getColor("text.disabled")};
                            font-size: ${getProp("theme.typography.headerSecondary.size")};
                            font-weight: bold;
                            line-height: normal;
                            color: #666 !important;
                            padding: 5.5px 10px 3.5px;
                            margin: 0;
                            display: inline-flex;
                            align-items: center;
                            margin: 0 9px 0 0;
                            span {
                                text-decoration: none;
                            }
                            button {
                                span {
                                    top: 1px !important;
                                }
                            }
                        `,
                        css`
                            flex-direction: row;
                            border-radius: 4px;
                            background-color: ${getColor("text.disabled")};
                            font-size: ${getProp("theme.typography.headerSecondary.size")};
                            font-weight: bold;
                            line-height: normal;
                            color: #666 !important;
                            padding: 5.5px 9px 3.5px;
                            margin: 0;
                            display: inline-flex;
                            align-items: center;
                            margin: 0 10px 0 0;
                            span {
                                text-decoration: none;
                            }
                            button {
                                span {
                                    top: 1px !important;
                                }
                            }
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}

            @media only screen and (min-width: 768px) and (max-width: 1024px) {
                flex-direction: row-reverse;

                span {
                    margin: 1px 0px 1px 10px;
                }
            }
        `,
    },
    mobileExpandContainer: {
        css: css`
            display: flex;
            width: 100%;
            justify-content: space-between;
            border-radius: 4px;
            background-color: #f7f7f7;
            padding: 19px 15px 18px 15px;
            height: 59px;
            span {
                font-size: ${getProp("theme.typography.h6.size")};
                font-weight: 800;
                line-height: normal;
                color: #002856;
            }
        `,
    },
    mobileClearAll: {
        css: css`
            button {
                border-radius: 4px;
                border: solid 1px ${getColor("secondary")};
                background-color: #fff;
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                font-weight: bold;
                line-height: normal !important;
                color: ${getColor("secondary")};
                padding: 5.5px 20px 3.5px !important;
                width: auto;
                height: auto;
                min-height: 34px;
                margin: 12px 8px 0 0;
            }
        `,
    },
    mobileContainer: {
        css: css`
            padding: 0 10px;
            display: flex;
            margin-bottom: 12px;
            width: 100%;
            flex-wrap: wrap;
            gap: 10px;
        `,
    },
    mobileFilters: {
        css: css`
            width: 100%;
        `,
    },
    toggleMsg: {
        css: css`
            font-size: 16px !important;
            font-weight: normal !important;
            line-height: normal !important;
            letter-spacing: normal !important;
            color: ${getColor("primary")} !important;
        `,
    },
    categoryHirerachy: {
        css: css`
            display: flex;
            gap: 5px;
            margin-right: 5px;
        `,
    },
};

const styles = filterListStyles;

interface FacetBreadcrumbProps {
    isMobile: boolean;
}

const FacetBreadcrumb = withCoveoHooks(({ isMobile, breadcrumbManager }: FacetBreadcrumbProps & HasCoveoHooks) => {
    const { state: breadcrumbManagerState, methods: breadcrumbManagerMethods } = breadcrumbManager;
    const anyActiveFilters = breadcrumbManagerState?.hasBreadcrumbs;
    const mobileStyles = isMobile ? styles.mobileContainer : {};
    const clearStyles = isMobile ? styles.mobileClearAll : styles.appliedFiltersContainer;

    return (
        <StyledWrapper {...mobileStyles} style={isMobile ? { width: "100%" } : {}}>
            {anyActiveFilters && (
                <StyledWrapper {...clearStyles}>
                    {!isMobile && (
                        <Typography {...styles.appliedFiltersText}>{translate("Applied Filters")}</Typography>
                    )}
                    <Link
                        {...styles.clearAllLink}
                        onClick={() => breadcrumbManagerMethods?.deselectAll()}
                        data-test-selector="productListClearAll"
                    >
                        {translate("Clear All")}
                    </Link>
                </StyledWrapper>
            )}

            <StyledWrapper {...styles.tagsContainer}>
                <StyledWrapper {...styles.allTagsContainer}>
                    {breadcrumbManagerState?.facetBreadcrumbs.map((facetBreadcrumb: Breadcrumb<any>, index: number) =>
                        facetBreadcrumb.values
                            ? facetBreadcrumb.values.map((breadcrumb: any, idx: number) => {
                                  const isAvailabilityFacet = facetBreadcrumb.facetId === "ec_availability";
                                  const value = breadcrumb.value?.value;
                                  const isInStockOrSpecialOrder = value === "In Stock" || value === "Special Order";
                                  const display = isAvailabilityFacet && !isInStockOrSpecialOrder ? "My Branch" : value;
                                  return (
                                      <Tag
                                          key={idx + index}
                                          {...filterListStyles.filterTag}
                                          onDelete={() => breadcrumb.deselect()}
                                          data-test-selector={`facetBreadcrumb-${index}`}
                                          noBackColor={true}
                                      >
                                          {display}
                                      </Tag>
                                  );
                              })
                            : null,
                    )}
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
});

const CoveoProductListFilterList: FC<Props> = ({
    attributeTypeFacets,
    showMobileFilters,
    id,
    showMobileFiltersState,
    breadcrumbManager,
}) => {
    const [toggle, setToggleState] = useState(false);
    const [isMobile, setIsMobile] = useState<boolean>(false);

    const getFiltersCount = () => {
        let count = 0;
        breadcrumbManager.state?.facetBreadcrumbs?.forEach((breadCrumb: any) => {
            count = count + breadCrumb.values.length;
        });
        return count;
    };

    useEffect(() => {
        const onWindowResize = () => {
            if (window.innerWidth >= 900) {
                setIsMobile(false);
            } else {
                setIsMobile(true);
            }
        };
        onWindowResize();

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", onWindowResize);
            }
        };
    }, []);

    useEffect(() => {
        showMobileFilters({
            showMobileFilters: isMobile,
        });
    }, [isMobile, attributeTypeFacets, showMobileFiltersState]);

    return (
        <StyledWrapper {...styles.wrapper}>
            {showMobileFiltersState ? (
                <>
                    <StyledWrapper
                        {...styles.mobileExpandContainer}
                        onClick={() => {
                            setToggleState(!toggle);
                        }}
                    >
                        <Typography>{translate("Filter Results")} </Typography>
                        <Typography {...styles.toggleMsg}>
                            {!toggle ? translate("+ Expand") : translate("- Collapse")}
                        </Typography>
                    </StyledWrapper>
                    {toggle && (
                        <>
                            <FacetBreadcrumb isMobile={true} breadcrumbManager={breadcrumbManager} />
                            {isMobile ? (
                                <StyledWrapper {...styles.mobileFilters}>
                                    <Zone contentId={id} zoneName="mobileFilter"></Zone>
                                </StyledWrapper>
                            ) : null}
                        </>
                    )}
                </>
            ) : (
                <>
                    <Typography {...styles.filterText} data-test-selector="productListFilterList">
                        {translate("Filter Results")}
                    </Typography>
                    <StyledWrapper style={{ width: "100%" }}>
                        <FacetBreadcrumb isMobile={false} breadcrumbManager={breadcrumbManager} />
                    </StyledWrapper>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCoveoHooks(CoveoProductListFilterList)),
    definition: {
        group: "Product List",
        displayName: "Coveo Filter List",
        allowedContexts: ["ProductListPage", "CategoryDetailsPage"],
    },
};

export default widgetModule;
